import ComponentsPage from './components/ComponentsPage';
import NoAvailableSectionsPage from './components/NoAvailableSectionsPage';

const routes = [
  {
    path: '/no-access',
    name: 'menu.noAccess',
    icon: 'bank',
    loginRequired: true,
    component: NoAvailableSectionsPage,
    weight: 999,
    permission: [],
    children: [],
    hideOnMenu: true,
    forMobile: false,
  },
  {
    path: '/components',
    name: 'menu.components',
    icon: 'bank',
    loginRequired: true,
    component: ComponentsPage,
    weight: 999,
    permission: [],
    children: [],
    hideOnMenu: true,
    forMobile: false,
  },
];

export default routes;
